import { useQueryClient } from '@tanstack/react-query'

import { useIndividualsServiceDeleteV1IndividualsByIndividualIdDocumentsByDocumentIdFilesByFileId } from '../client/queries'
import {
  useIndividualsServiceGetV1IndividualsByIndividualIdKey,
  type IndividualsServiceDeleteV1IndividualsByIndividualIdDocumentsByDocumentIdFilesByFileIdMutationResult,
} from '../client/queries/common'
import {
  optimisticallyEditDocuments,
  rollbackDocuments,
  type IndividualSnapshots,
} from './optimistic-documents'

export const useDeleteFile = () => {
  const queryClient = useQueryClient()

  return useIndividualsServiceDeleteV1IndividualsByIndividualIdDocumentsByDocumentIdFilesByFileId<
    IndividualsServiceDeleteV1IndividualsByIndividualIdDocumentsByDocumentIdFilesByFileIdMutationResult,
    unknown,
    IndividualSnapshots
  >({
    onError: (_error, _variables, context) => rollbackDocuments(queryClient, context),
    // Drop the file on click, and the whole document when that was its last
    // file — mirroring what the backend does, so the UI doesn't briefly show an
    // empty document container.
    onMutate: ({ documentId, fileId }) =>
      optimisticallyEditDocuments(queryClient, (documents) =>
        documents.flatMap((d) => {
          if (d.id !== documentId) return [d]
          const files = d.files.filter((f) => f.id !== fileId)

          return files.length === 0 ? [] : [{ ...d, files }]
        }),
      ),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [useIndividualsServiceGetV1IndividualsByIndividualIdKey],
      })
    },
  })
}
